module.exports = __webpack_public_path__ + "img/pdf.fb28e8d2.svg";